export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10440.399d3117.jpg";